import { Button, VStack } from "@chakra-ui/react";
import { yupResolver } from "@hookform/resolvers/yup";
import { InputTextArea } from "components/Atomos/Form/Elements/InputTextArea";
import { CommentFormData, commentSchema } from "models/comment.model";
import { FormComponentProps } from "models/loginForm";
import { useState } from "react";
import { useForm } from "react-hook-form";

type CommentFormProps = FormComponentProps<CommentFormData> & {
    isFinished?: boolean
};

const CommentForm = ({
    isFinished,
    onSuccess,
    onFailed
}: CommentFormProps) => {
    const [loading, setLoading] = useState(false);
    const { register, handleSubmit } = useForm<CommentFormData>({
        resolver: yupResolver(commentSchema)
    });

    const onSubmit = async (data: CommentFormData) => {
        setLoading(true);
        try {
            await onSuccess(data);
        } catch (err) {
            onFailed?.(err);
        } finally {
            setLoading(false);
        }
    }

    return (
        <VStack as="form" onSubmit={handleSubmit(onSubmit)}>
            <InputTextArea
                label="Escreva uma resposta ao usuário"
                register={register}
                name="comment"
                rows={5}
                isDisabled={isFinished}
            />

            <Button type="submit" isLoading={loading} disabled={isFinished}>Responder</Button>
        </VStack>
    )
}
export default CommentForm